import axios from "axios";

export const index = (requestParams, callback) => {
  var promise = axios({
    method: 'get',
    url: Routes.abstract_workflow_groups_path({...{...requestParams}, format: 'json', _options: true }),
    headers: {
      "X-CSRF-TOKEN": window.compliance.token,
    },
  });

  promise
    .then(response => {
      callback(response);
    })
    .catch(error => {
      callback(error.response);
    });
}
